import { mergeWith, uniqWith, isEqual, isArray } from 'lodash';
import {
  CACHED_SEARCH_SUCCESS,
  SEARCH_SUCCESS,
  SEARCH_UPDATE_SUCCESS,
  CLEAR_SEARCH_RESULTS,
} from '../actions/search';
import { SEARCH_BUNDLE_SUCCESS } from '../actions/bundles';

const initialState = {
  results: [],
  bundles: [],
  query: '',
  totalCount: 0,
};

/**
 * Use a custom merge comparator for lodash, because by default they concat arrays
 */
// eslint-disable-next-line consistent-return
const mergeArrays = (a, b) => {
  if (isArray(a)) {
    return uniqWith(a.concat(b), isEqual);
  }
};

// eslint-disable-next-line default-param-last
function search(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SUCCESS:
      return {
        results: action.payload,
        query: action.query,
        totalCount: action.meta.totalCount,
      };
    case SEARCH_UPDATE_SUCCESS:
      if (!action.payload) {
        return state;
      }
      return mergeWith(
        {},
        state,
        {
          results: action.payload,
          totalCount: action.meta.totalCount,
        },
        mergeArrays,
      );
    case SEARCH_BUNDLE_SUCCESS:
      return {
        bundles: action.payload,
        query: action.query,
      };
    case CLEAR_SEARCH_RESULTS: {
      return {
        results: [],
        query: '',
        totalCount: 0,
      };
    }

    default:
      return state;
  }
}

// initial state is diff
// eslint-disable-next-line default-param-last
export const cachedSearch = (state = {}, action) => {
  switch (action.type) {
    case CACHED_SEARCH_SUCCESS:
      return { ...state, [action.meta.hash]: action.payload };
    default:
      return state;
  }
};

export default search;
